import axios from "@/plugins/axios";

export default {
  async CreateBookingStatus({}, credentials) {
    const payload = {
      name: credentials.name,
      sortform: credentials.sortform,
      color_code: credentials.color_code,
    };
    return new Promise((resolve, reject) => {
      axios
        .post("/booking-statuses", payload)
        .then((resp) => resolve(resp))
        .catch((err) => reject(err.response));
    });
  },

  async EditBookingStatus({}, credentials) {
    const id = credentials.id;
    const payload = {
      name: credentials.name,
      sortform: credentials.sortform,
      color_code: credentials.color_code,
      is_active: credentials.is_active,
    };
    return new Promise((resolve, reject) => {
      axios
        .patch(`/booking-statuses/${id}`, payload)
        .then((resp) => resolve(resp))
        .catch((err) => reject(err.response));
    });
  },

  ActiveOrArchiveBookingStatus({}, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/booking-statuses/${id}/soft-delete`)
        .then((resp) => resolve(resp))
        .catch((err) => reject(err.response));
    });
  },
};
